import React from 'react'
import PropTypes from 'prop-types'

import Breadcrumbs from './../block/Breadcrumbs'
import Cards1 from './../block/Cards1'
import Raschet from './../block/Raschet'
import Kontakti from './../block/Kontakti'

class Partners extends React.Component {

  render() {

    const { data, protocol, assets_path } = this.props

    return (
      <>
        <Breadcrumbs items={data?.breadcrumbs || []} />
        <Cards1
          list={data?.circlecards3?.list || []}
          title={data?.circlecards3?.title || []}
          margin={`top-17`}
          cols={`2`}
          layout={13}
          bg={`2`}
        />
        <Cards1
          list={data?.dileram?.list || []}
          margin={`y`}
          layout={14}
          cols={`2`}
        />
        <Raschet
          data={data?.raschet || {}}
          assets_path={assets_path}
          dark_bg={data?.dark_bg || ''}
          dark_bg_mob={data?.dark_bg_mob || ''}
          variant={`zavod`}
        />
        <Kontakti
          data={data?.kontakti || {}}
          assets_path={assets_path}
          cardsOnly={true}
        />
      </>
    )
  }
}

Partners.propTypes = {
  data: PropTypes.object,
  protocol: PropTypes.string,
  assets_path: PropTypes.string
}

Partners.defaultProps = {
  data: {},
  protocol: 'https',
  assets_path: 'assets'
}

export default Partners